import { EDocumentType } from '@if/core/types'

export const getIncomeVerificationDocumentsTypes = [
  EDocumentType.DisabilityIncomeProof,
  EDocumentType.LastPayStubJob,
  EDocumentType.SixMonthsPersonalBankStatements,
  EDocumentType.FamilyAllocationsProof,
  EDocumentType.WorkIncidentIndemnisationProof,
  EDocumentType.MaternityPaternityIncomeProof,
  EDocumentType.OtherIncomeProof,
  EDocumentType.RetirementIncomeProof,
  EDocumentType.AssistanceProof,
  EDocumentType.EmployementInsuranceProof,
]

export const getIdentityDocumentTypes = [EDocumentType.ValidPhotoId]
